export enum ResultType {
    STAGE, ROUND, COMPETITION, SEASON
}